module.exports = __webpack_public_path__ + "img/Social.e2b328a4.png";